import { createFileRoute } from '@tanstack/react-router';
import { ensureSandboxOrRedirect } from '@/lib/utils/planner/ensureSandboxOrRedirect';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/sandbox')({
  beforeLoad: async ({ params: { loopId, org }, context: { queryClient } }) => {
    await ensureSandboxOrRedirect({ loopId, org, queryClient });
  },
});
